import { ListingSolution } from "../ListingSolution";
import { JobStatusName } from "./JobStatusName";
import { JobStatusType } from "./JobStatusType";

export interface JobStatus {
  integrationId: ListingSolution;
  sellerId: string;
  status: JobStatusName;
  type: JobStatusType;
}

export function isJobComplete(status?: string): boolean {
  return status === JobStatusName.COMPLETE || status === JobStatusName.SUCCESS;
}
